import { useState, useEffect } from 'react'
import store from '@/core/store'

function useRenderEvent (eventList, callback = () => {}) {
  const [lastRender, setLastRender] = useState(Date.now())

  useEffect(() => {
    eventList.forEach((event) => {
      store.on(event, (param) => {
        setLastRender(Date.now())
        callback(param)
      })
    })

    return function cleanup () {
      // eslint-disable-next-line
      eventList.forEach((event) => {
        // TODO: event cleanup should be here when component umounts
      },)
    }
  }, [])

  return lastRender
}

export default useRenderEvent
